export default class Dev {
    static dev_mode = false

    static log(...args: any[]) {
        if (Dev.dev_mode)
            console.log(...args)
    }
}